export default {
  entityName: "Holiday Calendar",
  apiEndpoint: "/master/holiday-calendars",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "Holiday Name", sortable: true },
    { key: "date", label: "Holiday Date", sortable: true, formatter: (val) => val ? new Date(val).toLocaleDateString() : '—' },
    { key: "type", label: "Category", sortable: true },
  ],
  fields: [
    { name: "name", label: "Holiday Name", type: "text", required: true, placeholder: "e.g. Independence Day" },
    { name: "date", label: "Holiday Date", type: "date", required: true },
    { name: "type", label: "Holiday Type", type: "select", required: true, options: ["public", "restricted", "company_holiday"], default: "public" },
  ],
  filters: [],
  workflow: {
    enabled: false,
  },
};
